// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4407":"css/app.6696","5509":"css/admin-app.6696"}[chunkId] + ".css";
};